import { render } from "./youmeng.vue?vue&type=template&id=3354249a&scoped=true"
import script from "./youmeng.vue?vue&type=script&lang=js"
export * from "./youmeng.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3354249a"]])

export default __exports__